








import {
    Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import { PropType } from 'vue'
import OpenCardsStat from '@/components/OpenCardsStat.vue'
import TrelloClient, { TrelloCard } from '@/TrelloClient'

@Component({
    components: {
        OpenCardsStat,
    },
    props: {
        cards: {
            type: Array as PropType<TrelloCard[]>,
            default: [],
        },
    },
})
export default class extends Vue {

    get stats(): Array<Object> {
        let stats = []
        let s: any = TrelloClient.cardsStatistics((this as any).cards)
        stats.push({ desc: 'Task aperte', value: s.nTasks })
        stats.push({ desc: 'Task scadute', value: s.nOverdueTasks + ' [' + s.nOverdueTasksPercent + ']' })
        stats.push({ desc: 'Task scadute da più di una settimana', value: s.nOverdueTasks7 + ' [' + s.nOverdueTasks7Percent + ']' })
        return stats
    }

}
